import { BellOff, Zap, CalendarClock } from "lucide-react";

const MODES = [
  { key: "off", label: "Off", icon: BellOff, active: "bg-sbg-burgundy text-white" },
  { key: "instant", label: "Instant", icon: Zap, active: "bg-sbg-fuchsia text-white" },
  { key: "daily", label: "Daily summary", icon: CalendarClock, active: "bg-pt-purple text-white" },
];

function ModePicker({ value, onChange, testId }) {
  return (
    <div className="inline-flex rounded-full bg-sbg-blush/50 p-1" role="radiogroup" data-testid={testId}>
      {MODES.map((m) => (
        <button key={m.key} type="button" role="radio" aria-checked={value === m.key} data-testid={`${testId}-${m.key}`}
          onClick={() => onChange(m.key)}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${value === m.key ? m.active : "text-sbg-burgundy/70 hover:bg-white"}`}>
          <m.icon className="h-3.5 w-3.5" /> {m.label}
        </button>
      ))}
    </div>
  );
}

export function NotificationPrefs({ events, prefs, onChange }) {
  const groups = [...new Set(events.map((e) => e.group))];
  return (
    <div className="space-y-6" data-testid="notification-prefs">
      {groups.map((g) => (
        <div key={g}>
          <div className="text-xs font-bold uppercase tracking-wider text-sbg-raspberry">{g}</div>
          <div className="mt-2 divide-y divide-sbg-raspberry/10 rounded-2xl bg-white ring-1 ring-sbg-raspberry/10">
            {events.filter((e) => e.group === g).map((e) => (
              <div key={e.key} className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between" data-testid={`notif-row-${e.key}`}>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-bold text-sbg-burgundy">{e.label}</div>
                  <div className="text-xs text-sbg-burgundy/60">{e.desc}</div>
                </div>
                <ModePicker value={prefs[e.key] || "off"} onChange={(v) => onChange(e.key, v)} testId={`notif-${e.key}`} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
